export const RIDE_PHASE = {
  CANCELED: "canceled",
  FINISHED: "finished",
  SCHEDULED: "scheduled",
  IN_PROGRESS: "in_progress",
  ARRIVED: "arrived",
  ACCEPTED: "accepted",
  SEARCHING: "searching",
};

export function isScheduledPending(ride) {
  return Boolean(ride?.scheduled && !ride?.scheduled_activated);
}

export function getRidePhase(ride) {
  if (!ride) return null;
  if (ride.canceled) return RIDE_PHASE.CANCELED;
  if (ride.finished) return RIDE_PHASE.FINISHED;
  if (isScheduledPending(ride)) return RIDE_PHASE.SCHEDULED;
  if (ride.started) return RIDE_PHASE.IN_PROGRESS;
  if (ride.arrived) return RIDE_PHASE.ARRIVED;
  if (ride.accepted) return RIDE_PHASE.ACCEPTED;
  return RIDE_PHASE.SEARCHING;
}

export function isTerminalPhase(phase) {
  return phase === RIDE_PHASE.CANCELED || phase === RIDE_PHASE.FINISHED;
}

export function shouldShowPickupEta(ride) {
  return getRidePhase(ride) === RIDE_PHASE.ACCEPTED && ride?.pickup_time != null;
}

export function hasDriverInfo(ride) {
  return ride?.driver_name != null || ride?.plates != null || ride?.car_model != null;
}

export const isValidCoord = (lat, lng) =>
  lat != null && lng != null && !Number.isNaN(Number(lat)) && !Number.isNaN(Number(lng));

export function shouldShowDriver(ride) {
  return hasDriverInfo(ride);
}

export function shouldShowDriverOnMap(ride) {
  if (isScheduledPending(ride)) return false;
  return isValidCoord(ride?.current_latitude, ride?.current_longitude);
}

export function getMapFitCoords(ride) {
  if (!ride) return [];

  const coords = [];
  const add = (lat, lng) => {
    if (isValidCoord(lat, lng)) {
      coords.push([lat, lng]);
    }
  };

  const phase = getRidePhase(ride);

  if (!isScheduledPending(ride)) {
    add(ride.current_latitude, ride.current_longitude);
  }

  switch (phase) {
    case RIDE_PHASE.IN_PROGRESS:
      add(ride.destination_latitude, ride.destination_longitude);
      ride.waypoints
        ?.filter((waypoint) => !waypoint.visited)
        .forEach((waypoint) => add(waypoint.lat, waypoint.lng));
      break;
    case RIDE_PHASE.ACCEPTED:
    case RIDE_PHASE.ARRIVED:
      add(ride.location_latitude, ride.location_longitude);
      break;
    default:
      add(ride.location_latitude, ride.location_longitude);
      add(ride.destination_latitude, ride.destination_longitude);
      break;
  }

  return coords;
}
